
import * as React from 'react';
export function NoneContent():JSX.Element
{
    return (
        <div style={{width:30}}></div>
    );
}